module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/icon_send_01-6d15dfac99c110f21c91968cba1e3289.png";